import React from 'react';

import { AccountContext } from '../../../Context/AccountContext';
import { FilterContext } from '../../../Context/FilterContext';

import { AccountOrProfile, AccountSkinAnalysis } from '../../../MyLom/Account/EditAccount/Types';

import { formatDate } from '../../../Utils';
import { createAccountOrProfile } from '../../../Api/Account/Utils';
import { getAnalysisLabel } from '../../../SkinAnalysisTable/Components/SkinAnalysisTable';

import './FilterPanel.scss';

interface Props {
    toggleVisibility: () => void;
}
const FilterPanel: React.FunctionComponent<Props> = (props) => {
    const { accountData } = React.useContext(AccountContext);

    if (!accountData) {
        throw new Error('This kind of product filter will only work for logged in customers');
    }
    const { activeSkinAnalysis, standardFilterValues, onlineAnalysis } = React.useContext(FilterContext);

    const getSkinAnalysisData = (): { customer: AccountOrProfile; skinAnalysis: AccountSkinAnalysis } | null => {
        const fromMainAccount = accountData.skinAnalyses.find((skinAnalysis) => skinAnalysis.id === activeSkinAnalysis);

        if (fromMainAccount) {
            return {
                customer: createAccountOrProfile(accountData),
                skinAnalysis: fromMainAccount,
            };
        }

        let fromProfileResult: { customer: AccountOrProfile; skinAnalysis: AccountSkinAnalysis } | null = null;
        accountData.profiles.forEach((profile): void => {
            if (!profile.skinAnalyses) {
                return;
            }

            const fromProfile = profile.skinAnalyses.find((skinAnalysis) => skinAnalysis.id === activeSkinAnalysis);
            if (fromProfile) {
                fromProfileResult = {
                    customer: createAccountOrProfile(profile),
                    skinAnalysis: fromProfile,
                };
            }
        });

        return fromProfileResult;
    };

    const skinAnalysisData = getSkinAnalysisData();

    if (skinAnalysisData) {
        return (
            <div className="product-filter__panel space-between">
                <div className="product-filter__panel-contents">
                    <img
                        src={skinAnalysisData.skinAnalysis.consultant.image || ''}
                        className="product-filter__image"
                        width="50"
                        height="50"
                    />
                    <div>
                        <div className="product-filter__date">
                            {getAnalysisLabel(skinAnalysisData.skinAnalysis)}
                            {' ' + 'vom' + ' '}
                            {formatDate(new Date(skinAnalysisData.skinAnalysis.creationDateTime))}
                        </div>
                        <div className="product-filter__person">
                            von {skinAnalysisData.skinAnalysis.consultant.firstName}{' '}
                            {skinAnalysisData.skinAnalysis.consultant.lastName} für{' '}
                            {skinAnalysisData.customer.displayName}
                        </div>
                    </div>
                </div>
                <button
                    className="product-filter__button button button--secondary"
                    onClick={props.toggleVisibility}
                    type="button"
                >
                    ändern
                </button>
            </div>
        );
    } else if (standardFilterValues) {
        return (
            <div className="product-filter__panel space-between">
                <div className="product-filter__panel-contents">
                    <p>
                        <strong>Aktiver Filter:</strong> Standardfilter
                    </p>
                </div>
                <button
                    className="product-filter__button button button--secondary"
                    onClick={props.toggleVisibility}
                    type="button"
                >
                    ändern
                </button>
            </div>
        );
    } else if (onlineAnalysis) {
        return (
            <div className="product-filter__panel space-between">
                <div className="product-filter__panel-contents">
                    <p>
                        <strong>Aktiver Filter:</strong> Online-Hautbild-Analyse vom{' '}
                        {formatDate(new Date(onlineAnalysis.creationDateTime))}
                    </p>
                </div>
                <button
                    className="product-filter__button button button--secondary"
                    onClick={props.toggleVisibility}
                    type="button"
                >
                    ändern
                </button>
            </div>
        );
    } else {
        return (
            <div className="product-filter__panel">
                <div className="product-filter__label">Filter:</div>
                <button
                    className="product-filter__button button button--secondary"
                    onClick={props.toggleVisibility}
                    type="button"
                >
                    Filter wählen
                </button>
            </div>
        );
    }
};

export default FilterPanel;
